<template>
	<div class="container">
		<div class="frontpage">
			<div class="fp-cell fp-cell--1">
				<div class="fp-item">
					<p>
						<b>Gerry Conlon</b> began his musical career in Irish traditional music in his second year at Saint Roch's secondary school in Glasgow, where he became a founder member of the school ceilidh Band. 
						Under the guidance of the legendary Frank McArdle (principal teacher of Mathematics) he started playing the piano accordion and very quickly progressed from novice to champion. 
						<br /><br />
						During his traditional music career, Gerry won 12 Great Britain titles and 4 All-Ireland titles on both piano accordion and piano. 
						He also competed in the traditional Scottish music scene and won the All Britain Scottish Piano Accordion Championships in 1982.
					</p>
					
				</div>
			</div>
			<!-- <div id="profile-pics"> -->
				<div class="fp-cell fp-cell--2">
					<div class="fp-item-pic">
						<img
						src="../assets/bio-pic-1-128-184.jpg"
						alt="Gerry Conlon Biography"
						img-alt="Image"
						img-top
						/>
					</div>
				</div>
				<div class="fp-cell fp-cell--3">
					<div class="fp-item-pic">
						<img
						src="../assets/bio-pic-2-118-184.jpg"
						alt="Gerry Conlon Biography"
						img-alt="Image"
						img-top
						/>
					</div>
				</div>
				<div class="fp-cell fp-cell--4">
					<div class="fp-item-pic">
						<img
						src="../assets/bio-pic-3-128-184.jpg"
						alt="Gerry Conlon Biography"
						img-alt="Image"
						img-top
						/>
					</div>
				</div>
			<!-- </div> -->
			<div class="fp-cell fp-cell--5">
				<div class="fp-item">
					<p>
						At around 16 years of age Gerry was asked to perform as a guest at the finals of the West of Scotland accordion championships and, 
						as he was current Great Britain champion on both Scottish and Irish music, was privileged to do so. 
						<br/><br/>
						During that concert there was an interlude within which a small group of Irish dancers from the John McKenna school of Irish Dancing (An Comhdháil) 
						were due to perform. Unfortunately, the cassette tape to which the dancers were performing had snapped leaving them in a tricky situation! John approached Gerry, 
						knowing he had an Irish music connection, and asked if he could "fill in". 
						<br/><br/>
						That five minutes of costumes, light shoes, heavy shoes and crowd appreciation marked a very definite start to Gerry's 
						involvement in Irish dancing and, 30 years later, it's still going strong.
					</p>
				</div>
			</div>
			<div class="fp-cell fp-cell--7">
				<div class="row" colspan="3">
					<div class="fp-item">
						<p>
							From the snap of that cassette tape back in 1982 to the present day, Gerry has
							performed at feiseanna throughout the world. As well as performing extensively in 
							the U.K and Ireland, Gerry has played many times in Australia, New Zealand, 
							America, Canada and Russia.
							<br/><br/>
							In fact, most dancers at some point over the past 30+ 
							years would have danced to Gerry's music either at a feis or at class using one of
							Gerry’s recordings.
						</p>
					</div>
				</div>
				<div class="row return-btn" colspan="3">
					<button v-on:click="onClick" :class="['btn', 'return-btn-style', 'btn-block']">Back to Music</button>
				</div>
			</div>
			<div class="fp-cell fp-cell--6">
				<div class="fp-item">
					<p>
						In recent years, Gerry was musical Consultant to the film “Jig – the movie” and composed much of the incidental music used in the film. 
						<br/><br/>
						He also undertook a similar role in the making of “Irish Dancing Tweens” (a TLC Productions series for Sirens Media), part of which was filmed at the World Championships in Belfast in 2012. 
						<br/><br/>
						Most recently, Gerry was commissioned to compose specific pieces for the show “Murphy’s Legacy” which was touring in Europe and the Middle East until it was abruptly halted by COVID-19 early last year.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	emits: ["back-to-music-btn-clicked"],
	setup(any, { emit })
	{
		function onClick()
		{
			emit("back-to-music-btn-clicked")
		}
		return {
			onClick
		};
	},
});
</script>

<style lang="scss" scoped>
@import "../styles/palette";
// @import "../styles/layout";

.container {
	overflow-x: hidden;
	border-top: 1px solid $primary-purple-2;
	border-bottom: 1px solid $primary-purple-2;
	padding-right: 0px;
}

.return-btn {
	display: flex;
	align-items: center;
	justify-content: center;
}
.return-btn-style {
	border-radius: 25px;
	width: 160px;
	color: white;
	background-color: $primary-purple-2;
}
.frontpage {
	position: relative;
	display: grid;
	grid-template-columns: 2fr 1fr 1fr 1fr 2fr;
	grid-gap: 1px;
	margin: 0 -16px;
	background-color: $primary-purple-2;
	color: $primary-purple-2;
	font-family: Apple Chancery, cursive;
	font-style: italic;
	font-size: 14px;
	background-image: url('../assets/single-notes-bkg.jpg');
}
	

.fp-cell {
	background-color: #fff;
	padding: 16px;
}

// Top cell "Gerry Conlon began..."
.fp-cell--1 {
	grid-column: 1 / span 7;
	padding-bottom: 0px;
}

// Photograph Cells
.fp-cell--2 {
	grid-column: 2 / span 1;
	max-height: 150px;
}
.fp-cell--3 {
	grid-column: 3 / span 1;
	max-height: 150px;
}
.fp-cell--4 {
	grid-column: 4 / span 1;
	max-height: 150px;
}
.fp-item-pic {
	display: flex;
	align-items: left;
	justify-content: center;
	min-height: 130px;
	height: 100%;
	background-color: white;
}
//#profile-pics {
	// display: flex;
	// flex-direction: row;
//}
// End Photographs

// At around 16 years...
.fp-cell--5 {
  grid-row: 2 / span 3;
  padding-bottom: 0px;
}
// END: At around 16 years

// From the snap of...
.fp-cell--7 {
  grid-column: 2 / span 3;
  grid-row: 3 / span 2;
  padding-bottom: 0px;
}
// END: From the snap of

// In recent years...
.fp-cell--6 {
  grid-column: 5 / span 1;
  grid-row: 2 / span 3;
}
// END: In recent years

// All of the text boxes
.fp-item {
//   background-color: #efefef;
  display: flex;
  align-items: left;
  justify-content: center;
  min-height: 130px;
  height: 100%;

  p {
		b {
			font-size: 24px;
		}
  }
}
@media only screen and (max-width: 995px) {
	.fp-cell--2 {
		grid-column : 2 / span 3;
	}
	.fp-cell--3 {
		grid-row: 3;
		grid-column : 2 / span 3;
	}
	.fp-cell--4 {
		grid-row: 4;
		grid-column: 2 / span 3;
		// padding-bottom: 0px;
	}
	.fp-cell--7 {
		grid-column: 2 / span 3;
		grid-row: 5 / span 2;
	}
}
// @media only screen and (max-width: 992px) {
// 	.fp-cell--2,
// 	.fp-cell--3,
// 	.fp-cell--4 {
// 		max-height: 190px;
// 		// padding-bottom: 0px;
// 	}
// }

// @media only screen and (max-width: 1360px) {
// 	#track-panels
// 	{
// 		flex-wrap: wrap;
// 	}
// }
// @media only screen and (max-width: 1024px) {
// 	#track-panels
// 	{
// 		flex-wrap: wrap;
// 	}
// }
@media only screen and (max-width: 860px) {
	.profile-pic {
		height: 140px;
	}
	.landing-splash-h3 {
		font-size: 18px;
	}
}
@media only screen and (max-width: 780px) {
	.profile-pic {
		height: 130px;
	}
	.grade-filters {
		flex-wrap: wrap;
	}
	#dance-filters
	{
		flex-wrap: wrap;
	}
}
@media only screen and (max-width: 680px) {
	.profile-pic {
		height: 130px;
	}
	.landing-splash-h1 {
		p {
			margin-top: 10px;
			font-size: 48px;
		}
	}
	.grade-filters {
		flex-wrap: wrap;
	}
	#dance-filters
	{
		flex-wrap: wrap;
	}
}
@media only screen and (max-width: 540px) {
	.profile-pic {
		height: 120px;
	}
	.landing-splash-h1 {
		p {
			margin-top: 10px;
			font-size: 44px;
		}
	}
}
@media only screen and (max-width: 415px) {
	.landing-splash-h1 {
		p {
			margin-top: 10px;
			font-size: 32px;
		}
	}
	.profile-pic {
		height: 85px;
	}
	// .frontpage {
	// 	display: flex;
	// 	grid-gap: 0;
	// 	flex-direction: column;
	// }
	// .fp-item-pic {
	// 	display: flex;
	// }
	// .profile-pics {
	// 	display: flex;
	// }
}
@media only screen and (max-width: 375px) {
	.profile-pic {
		display: none;
	}
	#biography {
		display: none;
	}
	.biography-label {
		display: none;
	}
	// .frontpage {
	// 	display: flex;
	// 	grid-gap: 0;
	// 	flex-direction: column;
	// }
	// .fp-item-pic {
	// 	display: flex;
	// }
	// .profile-pics {
	// 	display: flex;
	// 	flex-direction: row;
	// }
}
@media only screen and (max-width: 320px) {
	.profile-pic {
		display: none;
	}
	.landing-splash-h1 {
		p {
			margin-top: 10px;
			font-size: 24px;
		}
	}
	.landing-splash-h3 {
		font-size: 14px;
	}
	// .frontpage {
	// 	display: flex;
	// 	grid-gap: 0;
	// 	flex-direction: column;
	// }
	// .fp-item-pic {
	// 	display: flex;
	// }
}

@media only screen and (max-width: 280px) {
	.landing-splash-h1 {
		p {
			margin-top: 15px;
			font-size: 24px;
			font-style: italic;
			font-weight: bold;
		}
	}
	.landing-splash-h3 {
		font-size: 14px;
	}
	.landing-splash-h4 {
		p {
			font-size: 8px;
		}
	}
	// .frontpage {
	// 	display: flex;
	// 	grid-gap: 0;
	// 	flex-direction: column;
	// }
	// .fp-item-pic {
	// 	display: flex;
	// }
}
</style>
